module.exports = __webpack_public_path__ + "5065dc2845b64380de2a0e1763000c42.MP3";